import { createModuleRoutePaths } from "src/system/createModuleRoutePaths.ts";
import { createResourceStorageKeys } from "src/framework/createResourceStorageKeys.ts";
import type { Router } from "@remix-run/router";
import type { UserResource } from "@exonn/js-sdk";
import { getUserDataState } from "src/user-data/getUserDataState.ts";
import { ModuleLayoutTabsUserDataSchema } from "src/user-data/schemas.ts";
import type { ModuleTabsPersistedState } from "src/user-data/types.ts";

export const openModule = ({
  resource,
  router,
  user,
}: {
  resource: string;
  router: Router;
  user: UserResource;
}) => {
  return router.navigate(
    getModuleFirstTabPath({
      resource,
      user,
    }),
  );
};

export const getModuleFirstTabPath = ({
  resource,
  user,
}: {
  resource: string;
  user: UserResource;
}) => {
  const modulePaths = createModuleRoutePaths({
    resource,
  });
  const storageKeys = createResourceStorageKeys({
    resource,
  });
  const modulePath = modulePaths.root;

  const state = getUserDataState<ModuleTabsPersistedState>({
    user,
    key: storageKeys.tabs,
    validationSchema: ModuleLayoutTabsUserDataSchema,
    defaultValue: {
      paths: [modulePath],
    },
  });

  return state.paths[0];
};
